import React from 'react'

import FormManager from "../../../gd-form/common/form-manager"
import ButtonSubmitDeprecated from "../../../gd-form/common/btn-submit/btn-submit-ui5"

type Props = {
    form: FormManager
}

export default function CustomFieldActions(props: Props) {
    return (
        <div className="bottom-action">
            <ButtonSubmitDeprecated form={props.form} className="submit" label="Save"/>
        </div>
    )
}